import { ApiTableFilter } from '../../shared/models/table-filter.model';

/**
 * Matches React AttributesTable `formatFilters`:
 * Type / Created By columns have no MUI `type`, so the API `type` is always `string`.
 * Type values are `attributeTypesMap` option values (Picklist, Text, …, and GS1 as `'GS1'`).
 */
export function toAttributesApiFilters(filters: ApiTableFilter[]): ApiTableFilter[] {
  return filters.map((filter) => ({
    column: filter.column,
    operator: filter.operator,
    value: unwrapAttributesFilterValue(filter.value),
    type:
      filter.column === 'type' ||
      filter.column === 'created_by' ||
      filter.type === 'singleSelect'
        ? 'string'
        : filter.type,
  }));
}

function unwrapAttributesFilterValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map((item) => unwrapAttributesFilterValue(item));
  }

  if (value && typeof value === 'object' && 'value' in value) {
    return (value as { value: unknown }).value;
  }

  return value;
}
